import React, {useEffect, useState} from 'react';

import {Formik, Field, Form, ErrorMessage, useFormik} from 'formik';
import {alertService} from '@app/services/alertService';
//import {nhaphanphoiService} from '@app/services/nhaphanphoiService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole} from '@app/services/mainService';
import { myService } from "@app/services/banggiaService";
import {Button} from "react-bootstrap";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import {INIT_ROLE_MENU} from "@app/const/AppSetting";
import {ClipLoader} from "react-spinners";
import NewDatePicker from "@pages/FUtil/NewDatePicker";
import KhachhangListComponent from "@pages/FUtil/KhachhangListComponent";
import {FormInput} from "@components";
function BanggiaEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    const initArr = [];
    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;


    const [handleToogle, setHandleToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const initial = {
        sanpham_fks: [],
        id: id,
        ten: '',
        trangthai_fk: 0,
        khachhang_fk: 0,
        tungay: new Date().toISOString().split('T')[0],
        denngay: new Date().toISOString().split('T')[0]
    };
    const [obj, setObj] = useState({...initial});
    const [sanphamList,setSanPhamList] = useState(initArr);

    const onChangeInput = (e) => {
        const {name, value} = e.target;
        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));

    };

    // Cập nhật giá trị đơn giá AVAT theo index
    const onChangeAVAT = (index, value) => {
        console.log('vao onchange: '+index + value);
        setObj(prev => {
            const updatedList = [...prev.sanpham_fks];
            updatedList[index] = {
                ...updatedList[index],
                dongiaavat: value
            };
            return { ...prev, sanpham_fks: updatedList };
        });
        console.log('sau onchange', JSON.stringify(obj, null, 2));
    };

    // Cập nhật giá trị đơn giá AVAT theo index
    const onChangePTCK = (index, value) => {
        console.log('vao onchange: '+index + value);
        setObj(prev => {
            const updatedList = [...prev.sanpham_fks];
            updatedList[index] = {
                ...updatedList[index],
                ptchietkhau: value
            };
            return { ...prev, sanpham_fks: updatedList };
        });
        console.log('sau onchange', JSON.stringify(obj, null, 2));
    };

    // Cập nhật giá trị đơn giá BVAT theo index
    const onChangeBVAT = (index, value) => {
        console.log('vao onchange: '+index + value);
        setObj(prev => {
            const updatedList = [...prev.sanpham_fks];
            updatedList[index] = {
                ...updatedList[index],
                dongiabvat: value
            };
            return { ...prev, sanpham_fks: updatedList };
        });
        console.log('sau onchange', JSON.stringify(obj, null, 2));
    };


    async function createUser(data) {
       setLoading(true);
               // delete data.ma;
               const result = await myService.Create(data);
               if (result.status ==="1") {
                   alertService.success(result.msg);
                   
                   history.push('/'+currController);
       
               } else {
                   alertService.error(result.msg);
               }
               setLoading(false);
    }

    async function updateUser(id, data) {
        setLoading(true);
             
               const result = await myService.Update(id,data);
               if (result.status ==="1") {
                   alertService.success(result.msg);
                 
               } else {
                   alertService.error(result.msg);
               }
               setLoading(false);
    }

    const createRs = async () => {
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        try {
            // Lấy danh sách tất cả sản phẩm
            const basePriceRes = await myService.getBasePrice(obj.khachhang_fk);
            const allProducts = basePriceRes.data.data || []; // Danh sách tất cả sản phẩm
            console.log('Base Price:', allProducts);

            if (!isAddMode) {
                // Nếu là Edit Mode, lấy thông tin bảng giá hiện tại
                const editPriceRes = await myService.getById(id);
                const editData = editPriceRes.data.data || {};
                const editPriceList = editData.sanpham_fks || []; // Danh sách bảng giá đã lưu
                console.log('Existing Price:', editPriceList);

                // Dùng Map để ghép giá cũ vào danh sách sản phẩm
                const priceMap = new Map(editPriceList.map(p => [p.sanpham_fk, p]));

                // Merge dữ liệu: nếu sản phẩm đã có giá cũ thì giữ nguyên, nếu không thì set giá = 0
                const mergedSanPhamList = allProducts.map(sp => ({
                    ...sp,
                    ...(priceMap.get(sp.sanpham_fk) || { dongia_avat: 0, dongia_bvat: 0 })
                }));

                setObj(prev => ({
                    ...editData,
                    sanpham_fks: mergedSanPhamList
                }));

                console.log('Merged sanpham_fks:', mergedSanPhamList);
            } else {
                // Nếu là Add Mode thì chỉ lấy danh sách sản phẩm mới
                setObj(prev => ({
                    ...prev,
                    sanpham_fks: allProducts
                }));
            }
        } catch (error) {
            console.error('Lỗi khi gọi API:', error);
        }
    };


    useEffect(() => {
        (async () => {
            await checkRole({
                pathname: location.pathname,
                isAddMode,
                currController,
                history
            });
            await createRs();
        })();
    }, [obj.khachhang_fk]);



    const taoPKClick = () => {

        let data = obj;

        if(isAddMode)
        {
            createUser(data);
        }
        else
        {
            updateUser(id,data);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    let htmlButtonSave = '';
    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
                className="btn  btn-success  mr-1"

                icon="right fas fa-angle-left"
                onClick={taoPKClick}
            >
                <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
            </Button>
        );

    }

    const backBrowse = () => {
        history.push('/'+currController);
    };

    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-footer">
                <div className="col-md-6">
                    {htmlButtonSave}
                </div>
            </div>

            <div className="card-body">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i></Button>
                </div>
                <div className="row">

                    <div className="col-md-6">
                        <label htmlFor="ten">Tên bảng giá</label>
                        <input
                            id="ten"
                            name="ten"
                            type="text"
                            className="form-control"
                            value={obj.ten}
                            onChange={onChangeInput}
                        />
                    </div>
                    {!isAddMode && (
                        <div className="col-md-6">
                            <TrangthaiListComponent trangthai_fk = {obj.trangthai_fk}
                                                    onChange={(opt, e) => {
                                                        const target = {name: "trangthai_fk", value: opt?.value};
                                                        onChangeInput({target});
                                                    }}
                                                    filterIds = { [0,1] }
                                                    trangthaiName = "name"
                            />
                        </div>
                    )}

                </div>
                <div className="row">

                </div>

                <div className="row">
                    <div className="col-md-2">
                        <label className="required">Từ ngày</label>
                        <NewDatePicker required = "required" className="form-control w-100" isV2 id="tungay" name="tungay" value={obj.tungay} onDayChange={onChangeInput} />
                    </div>
                    <div className="col-md-2">
                        <label className="required">Đến ngày</label>
                        <NewDatePicker required = "required" className="form-control w-100" isV2 id="denngay" name="denngay" value={obj.denngay} onDayChange={onChangeInput} />
                    </div>
                    <div className="col-md-8">
                        <KhachhangListComponent required="required" name='khachhang_fk' labelName='Nha khoa' value={obj.khachhang_fk} onChange={(opt) => onChangeInput({ target: { name: "khachhang_fk", value: opt?.value } })} />
                    </div>
                </div>
                <hr/>


                <div className="row table-responsive">
                    <div className="col-md-12">
                        <table responsive bordered hover className="table table-bordered table-hover text-nowrap">
                            <thead>
                            <tr>
                                <th className="col-md-2 text-center">SẢN PHẨM/DỊCH VỤ</th>
                                <th className="col-md-1 text-center">% Chiết khấu</th>
                                <th className="col-md-1 text-center">ĐƠN GIÁ AVAT</th>
                                <th className="col-md-1 text-center">ĐƠN GIÁ BVAT</th>
                            </tr>
                            </thead>
                            <tbody>
                            {obj.sanpham_fks.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.sanpham_name}</td>
                                    <td>
                                        <FormInput
                                            name={index}
                                            id={`idptck-${index}`}
                                            type="number"
                                            value={item.ptchietkhau || ''}
                                            onChange={onChangePTCK}
                                        />
                                    </td>
                                    <td>
                                        <FormInput
                                            name={index}
                                            id={`idgiavon-${index}`}
                                            type="number"
                                            value={item.dongiaavat || ''}
                                            onChange={onChangeAVAT}
                                        />
                                    </td>
                                    <td>
                                        <FormInput
                                            name={index}
                                            id={`iddongia-${index}`}
                                            type="number"
                                            value={item.dongiabvat || ''}
                                            onChange={onChangeBVAT}
                                        />
                                    </td>
                                </tr>
                            ))}
                            </tbody>



                        </table>
                </div>
            </div>
            <div className="card-footer">
                <div className="col-md-6">
                    {htmlButtonSave}
                </div>
            </div>

            </div>



        </div>
    );
}

export {BanggiaEdit};
